import { render, staticRenderFns } from "./PracticeNotificationEmail.vue?vue&type=template&id=13b06847&scoped=true"
import script from "./PracticeNotificationEmail.vue?vue&type=script&lang=js"
export * from "./PracticeNotificationEmail.vue?vue&type=script&lang=js"
import style0 from "./PracticeNotificationEmail.vue?vue&type=style&index=0&id=13b06847&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b06847",
  null
  
)

export default component.exports